import {
  createStore,
  applyMiddleware,
  compose,
  reduxLogger,
  reduxThunk
} from '../../../libraries'
import { rootReducers } from '../reducers'

var middleware = []
if (process.env.NODE_ENV === 'development') {
  var middleware = [...middleware, reduxThunk, reduxLogger]
} else {
  var middleware = [...middleware, reduxThunk]
}

export const store = createStore(
  rootReducers,
  compose(
    applyMiddleware(...middleware)
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
)
